import { CatalogState } from "./catalog";
import { CartState } from "./cart";
import { UserState } from "./user";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { StoreState } from './store-state';

export interface AppState {
  catalogState: CatalogState;
  cartState: CartState;
  userState: UserState;
  storeState: StoreState
}
export let appInitialState: AppState = {
  catalogState: null,
  cartState: null,
  userState: null,
  storeState: null
};

export function appTestState(): AppState {
  return {
    catalogState: null,
    cartState: null,
    userState: null,
    storeState: null
  };
}

export const getAppState = createFeatureSelector<AppState>("appState");

export const getUser = createSelector(
  getAppState,
  (store: AppState) => store.userState.user
);

export const getStoreState = createFeatureSelector<StoreState>("storeState");

// export const token = createSelector(getUser,(user:User) => user)
